const wowApp = require('angular').module('oly.common');

wowApp.directive('wowHideScroll', ['BreakpointsService', require('./hidescroll.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/hidescroll/index.js